module.exports = __webpack_public_path__ + "img/category.e2131562.svg";